export const FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST =
  "FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST";
export const FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_SUCCESS =
  "FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_SUCCESS";
export const FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_FAILURE =
  "FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_FAILURE";
